// src/components/shops/postTemplates/MenuBoard.tsx
//
// The A-board outside, rebuilt for a phone: dark ground, condensed uppercase
// type, the item large enough to read at arm's length.
//
// It is the one template that is complete with no photograph at all, which is
// the point of it — a special decided at 6am gets posted at 6am instead of
// waiting for someone to stage a shot that never happens. A photo is welcome
// but it sits behind the type rather than leading.

import { cachedUrl } from '../../../lib/storageUrl'
import SocialBrewBadge from '../SocialBrewBadge'
import { categoryLabel, bodyLines, type TemplateProps } from './types'

export default function MenuBoard({
  title, body, photos, category, shopName, rating, ratingCount, scale = 1,
}: TemplateProps) {
  const px = (n: number) => `${n * scale}px`
  const label = categoryLabel(category) || 'Today'
  const lines = bodyLines(body)

  return (
    <div
      className="overflow-hidden"
      style={{ background: '#1c1008', borderRadius: px(4) }}
      data-shop={shopName}
    >
      {photos.length > 0 && (
        // A shallow band, dimmed so the board still reads as type first.
        <div style={{ aspectRatio: '16 / 7', position: 'relative' }}>
          <img src={cachedUrl(photos[0])} alt="" loading="lazy" className="w-full h-full object-cover" />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(28,16,8,0.15), rgba(28,16,8,0.92))' }} />
        </div>
      )}

      <div style={{ padding: `${px(photos.length > 0 ? 14 : 22)} ${px(18)} ${px(16)}` }}>
        <p
          style={{
            fontSize: px(9),
            letterSpacing: '0.32em',
            textTransform: 'uppercase',
            color: '#c8853a',
            fontWeight: 700,
            marginBottom: px(12),
          }}
        >
          {label}
        </p>

        <h3
          style={{
            fontSize: px(28),
            lineHeight: 1.04,
            letterSpacing: '0.01em',
            textTransform: 'uppercase',
            fontWeight: 800,
            color: '#f4ead9',
            margin: 0,
            textWrap: 'balance',
          }}
        >
          {title}
        </h3>

        {lines.length > 0 && (
          <div style={{ marginTop: px(12), borderTop: '1px solid rgba(244,234,217,0.16)', paddingTop: px(12) }}>
            {lines.map((line, i) => (
              <p
                key={i}
                style={{
                  fontSize: px(12.5),
                  lineHeight: 1.55,
                  color: 'rgba(244,234,217,0.78)',
                  margin: 0,
                  letterSpacing: '0.01em',
                }}
              >
                {line}
              </p>
            ))}
          </div>
        )}

        <div style={{ marginTop: px(18) }}>
          <SocialBrewBadge rating={rating} ratingCount={ratingCount} tone="dark" scale={scale} />
        </div>
      </div>
    </div>
  )
}
